import gql from 'graphql-tag';
import KEYBOARDING_DYNAMIC_CONTENT_FRAGMENT from './KeyboardingDynamicContent';
const EQUATION_BUILDER_ACTIVITY_FRAGMENT = gql `
  fragment EquationBuilderActivityFragment on EquationBuilderActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    rounds {
      hint {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      questionHtml {
        id
        elements
      }
      terms {
        id
        placeholder
        value
        operator
        fraction {
          numerator {
            id
            placeholder
            value
            operator
          }
          denominator {
            id
            placeholder
            value
            operator
          }
        }
      }
      optionalContent {
        ...KeyboardingDynamicContentFragment
      }
    }
  }
  ${KEYBOARDING_DYNAMIC_CONTENT_FRAGMENT}
`;
export default EQUATION_BUILDER_ACTIVITY_FRAGMENT;
